import React from 'react';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Termos de Uso - Cerveja Delivery</title>
      </Helmet>
      <div className="min-h-screen bg-cream-300 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-soft p-8 sm:p-12">
          <h1 className="font-display font-bold text-3xl sm:text-4xl text-dark-900 mb-8">Termos de Uso</h1>
          
          <div className="prose prose-amber max-w-none text-dark-600">
            <p className="text-sm text-dark-500 mb-8">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

            <h3 className="text-xl font-bold text-dark-900 mt-8 mb-4">1. Sobre o Serviço</h3>
            <p>
              O Cerveja Delivery é uma plataforma intermediária de tecnologia que conecta usuários (maiores de 18 anos) a cervejarias artesanais locais. Não somos fabricantes nem realizamos a entrega direta dos produtos, que é de responsabilidade das Cervejarias Parceiras.
            </p>

            <h3 className="text-xl font-bold text-dark-900 mt-8 mb-4">2. Maioridade Legal</h3>
            <p className="font-bold text-red-600">
              O uso desta plataforma é estritamente proibido para menores de 18 anos.
            </p>
            <p>
              Ao se cadastrar, você declara sob as penas da lei que possui mais de 18 anos de idade. A entrega dos produtos pode exigir a apresentação de documento com foto para comprovação de idade.
            </p>

            <h3 className="text-xl font-bold text-dark-900 mt-8 mb-4">3. Pedidos e Entregas</h3>
            <p>
              O contrato de compra e venda é estabelecido diretamente entre o Usuário e a Cervejaria. Prazos de entrega, qualidade do produto e emissão de nota fiscal são de responsabilidade exclusiva da Cervejaria Parceira.
            </p>

            <h3 className="text-xl font-bold text-dark-900 mt-8 mb-4">4. Cancelamentos</h3>
            <p>
              Cancelamentos podem ser solicitados através da plataforma ou contato direto com a cervejaria antes do despacho do pedido. Após o despacho, a política de devolução segue o Código de Defesa do Consumidor.
            </p>

            <h3 className="text-xl font-bold text-dark-900 mt-8 mb-4">5. Responsabilidades</h3>
            <p>
              O Cerveja Delivery não se responsabiliza por vícios de qualidade dos produtos ou atrasos na entrega, atuando apenas como vitrine virtual e facilitador do pagamento.
            </p>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-center">
                Dúvidas? Entre em contato conosco pelo email suporte@cerveja.delivery
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;